import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController } from "../../Common/ButtonController";
import { LocalizationContents } from "../../LocalizationContents";
import { AppStateEnum, GameModel } from "../../Models/GameModel";
import { resizeScreen } from "../../Utils/Resize";
import { SettingsButtonController } from "../Settings/SettingsButton";
import { LevelSelectorController } from "./LevelSelector";

export interface ILevelSelectionScreenOptions {

}

export class LevelSelectionScreen extends AnimationBaseController {
    $model: GameModel;

    constructor(
        @Inject private options: ILevelSelectionScreenOptions,
    ) {
        super("LevelSelectionScreen");
    }

    getConfiguration(): IAnimationControllerConfiguration {

        const children = {};



        return {
            animationContent: AnimationContents.LEVEL_SELECTION_JSON,
            libraryName: "route_selection_screen",
            childControllers: {
                level1: {
                    instanceName: "level1",
                    controller: LevelSelectorController,
                    options: {
                        level: 1,
                    },
                    model: this.$model,
                },
                level2: {
                    instanceName: "level2",
                    controller: LevelSelectorController,
                    options: {
                        level: 2,
                    },
                    model: this.$model,
                },
                backButton: {
                    instanceName: "btn_back_route_selection",
                    controller: ButtonController,
                    options: {
                        onClick: () => { this.$model.appState = AppStateEnum.garage; },
                    }
                }
            }
        }
    }

    onInitialize() {
        this.addChildControllerAsync({
            controller: SettingsButtonController,
            model: this.$model,
        }, false, "settingsButton");
        this.setTextByQuery("title_choose_track", LocalizationContents.getText("title_choose_track"));
        this.setTextVerticalAlignByQuery("title_choose_track", "middle")
    }

    protected onResize(width: number, height: number, scale: number): void {
        resizeScreen(width, height, scale, this);
    }
}